import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4859e79c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "topheader" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: "gfx/d-menu.svg" }),
  /*#__PURE__*/_createTextVNode(" MENU")
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "veripalvelu_englanti.png" })
], -1))
const _hoisted_5 = { class: "userBox" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Logout ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Messages not implemented yet. ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cleaner" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_Toast = _resolveComponent("Toast")!
  const _directive_badge = _resolveDirective("badge")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "hamburger",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
        }, _hoisted_3),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("i", {
            class: "pi pi-bell p-mr-4 p-text-secondary",
            style: {"font-size":"25px"},
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showMessage && _ctx.showMessage(...args)))
          }, null, 512), [
            [_directive_badge, 2]
          ]),
          _withDirectives(_createElementVNode("i", {
            class: "pi pi-envelope p-mr-4 p-text-secondary",
            style: {"font-size":"25px"},
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.overlay && _ctx.overlay(...args)))
          }, null, 512), [
            [
              _directive_badge,
              void 0,
              void 0,
              { danger: true }
            ]
          ]),
          _createElementVNode("i", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.settings && _ctx.settings(...args))),
            style: {"font-size":"25px"},
            class: "pi pi-cog p-text-secondary"
          }),
          _createVNode(_component_Button, {
            onClick: _ctx.logout,
            style: {"margin-left":"10px"},
            class: "p-button-rounded"
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_OverlayPanel, { ref: "op" }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 512)
        ]),
        _hoisted_8
      ])
    ]),
    _createVNode(_component_Toast)
  ], 64))
}